import Icon from '../components/Icon';

const Weather42Colored = Icon(
  'weather-42-colored',
  <>
    <path
      fill="#A180D3"
      fillRule="evenodd"
      d="M8.805 2.487a.75.75 0 0 1 1.06-.034L12 4.455l2.136-2.002a.75.75 0 0 1 1.026 1.094L12.706 5.85v4.85l4.2-2.425.766-3.278a.75.75 0 0 1 1.46.34l-.665 2.851 2.801.849a.75.75 0 1 1-.434 1.435l-3.105-.94-4.14 2.39 4.14 2.39 3.105-.94a.75.75 0 0 1 .434 1.435l-2.801.848.666 2.85a.75.75 0 1 1-1.46.342l-.767-3.278-4.2-2.425v4.85l2.456 2.303a.75.75 0 0 1-1.026 1.094L12 19.389 9.865 21.39a.75.75 0 1 1-1.026-1.094l2.367-2.22v-4.779l-4.14 2.39-.738 3.159a.75.75 0 1 1-1.46-.341l.666-2.85-2.802-.85a.75.75 0 0 1 .435-1.435l3.222.976 4.2-2.425-4.2-2.425-3.222.976a.75.75 0 0 1-.435-1.436l2.802-.848-.666-2.85a.75.75 0 1 1 1.46-.342l.738 3.159 4.14 2.39v-4.78L8.839 3.547a.75.75 0 0 1-.034-1.06"
      clipRule="evenodd"
    />
  </>
);

export default Weather42Colored;
